import { geocodeByAddress, getLatLng, geocodeByPlaceId } from 'react-places-autocomplete';
import Geocode from 'react-geocode';
import _ from 'lodash';
import store from '../../redux/store';
import { showMessageModal } from '../../redux/actions';
import {
  getClosestShops,
  isAddressValid,
  parseAddress,
  updateAddressAndShop,
  sendCloudWatchAlert,
  getAddressDetails,
  getShopIdMarketplaceLink,
  errorShopUnavailable
} from '../../utils';
import { validateAddressStuart } from '../../api';
import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
  WRONG_ADDRESS,
  UNAVAILABLE_ADDRESS
} from '../../constants';

export const onPressAddAddress = async (component, orderType) => {
  const { placeId, address } = component.state;
  try {
    const {
      onCancel,
      updateClosestShops,
      updateAddressTemp,
      showChooseShop,
      showAddressModal,
      marketplace,
      userConnected
    } = component.props;
    let customerAddress = {};
    component.setState({ loading: true });
    const { stuart, delivery } = store.getState().configurationReducer;
    const { shopName } = store.getState().shopReducer;
    const { chooseShop } = delivery;
    const marketplaceEnabled = marketplace && marketplace.enabled;
    try {
      let results = [];
      if (placeId) {
        results = await geocodeByPlaceId(placeId);
      } else {
        results = await geocodeByAddress(address);
      }
      customerAddress = parseAddress(results[0].address_components);
      const { lat, lng } = await getLatLng(results[0]);
      const addresses = await Geocode.fromLatLng(lat, lng);
      const { district, subLocality } = getAddressDetails(addresses.results);
      customerAddress.district = district;
      customerAddress.subLocality = subLocality;
      customerAddress.location = {
        latitude: lat,
        longitude: lng
      };
      customerAddress.orderType = orderType;
    } catch (error) {
      const errorMessage = String(error);
      if (!errorMessage.includes('INVALID_REQUEST') && !errorMessage.includes('ZERO_RESULTS')) {
        sendCloudWatchAlert(`Could not get address ${error}`);
      }
    }
    const shopIdFromLink = getShopIdMarketplaceLink();
    if (isAddressValid(customerAddress, orderType)) {
      const shops = await getClosestShops(customerAddress, orderType);
      if (marketplaceEnabled && shopIdFromLink) {
        const selectedShop = _.find(shops, shop => {
          return shop.shopId === shopIdFromLink;
        });
        if (!selectedShop) {
          throw errorShopUnavailable(shopName);
        }
      }
      if (shops.length > 0) {
        const shop = shops[0];
        updateAddressTemp(customerAddress);
        if (orderType === ORDER_TYPE_DELIVERY) {
          let isAddressValidStuart = true;
          if (stuart && userConnected) {
            isAddressValidStuart = await validateAddressStuart(
              customerAddress,
              (marketplaceEnabled && shopIdFromLink) || shop.shopId
            );
          }
          if (isAddressValidStuart) {
            if (marketplaceEnabled) {
              await updateClosestShops(shops);
              await updateAddressAndShop(
                shopIdFromLink || shop.shopId,
                customerAddress,
                ORDER_TYPE_DELIVERY
              );
              component.setState({ loading: false });
              showAddressModal(false);
            } else if (chooseShop && shops.length > 1) {
              await updateClosestShops(shops);
              component.setState({
                loading: false
              });
              showChooseShop(true);
            } else {
              await updateAddressAndShop(shop.shopId, customerAddress, ORDER_TYPE_DELIVERY);
              if (onCancel) {
                onCancel();
              }
              component.setState({ loading: false });
              showAddressModal(false);
            }
            return true;
          }
        } else if (orderType === ORDER_TYPE_CLICK_AND_COLLECT) {
          if (shops.length === 1) {
            await updateAddressAndShop(shop.shopId, customerAddress, ORDER_TYPE_CLICK_AND_COLLECT);
            component.setState({ loading: false });
            showAddressModal(false);
          } else {
            await updateClosestShops(shops);
            component.setState({
              loading: false
            });
            if (!marketplaceEnabled) {
              showChooseShop(true);
            } else {
              await updateAddressAndShop(
                shopIdFromLink || shop.shopId,
                customerAddress,
                ORDER_TYPE_CLICK_AND_COLLECT
              );
              showAddressModal(false);
            }
          }
          return true;
        }
      }
      throw UNAVAILABLE_ADDRESS;
    } else if (orderType === ORDER_TYPE_CLICK_AND_COLLECT) {
      const { customerAddress } = store.getState().userReducer;
      updateAddressTemp(null);
      const shops = await getClosestShops(null, orderType);
      const shop = shops[0];
      if (marketplaceEnabled) {
        if (customerAddress || shopIdFromLink) {
          await updateAddressAndShop(
            shopIdFromLink || shop.shopId,
            customerAddress || shop.address,
            ORDER_TYPE_CLICK_AND_COLLECT
          );
          component.setState({ loading: false });
          showAddressModal(false);
        } else {
          throw WRONG_ADDRESS;
        }
      } else if (shops.length === 1) {
        await updateAddressAndShop(shop.shopId, shop.address, ORDER_TYPE_CLICK_AND_COLLECT);
        component.setState({ loading: false });
        showAddressModal(false);
      } else {
        await updateClosestShops(shops);
        component.setState({
          loading: false
        });
        showChooseShop(true);
      }
    } else {
      throw WRONG_ADDRESS;
    }
  } catch (error) {
    let errorMessage = String(error);
    if (!errorMessage.includes('déployé sur') && !errorMessage.includes('incorrecte')) {
      sendCloudWatchAlert(`Could not add address ${address}: ${errorMessage}`);
    }
    if (errorMessage.includes('ZERO_RESULTS')) {
      errorMessage = UNAVAILABLE_ADDRESS;
    }
    store.dispatch(showMessageModal(errorMessage));
    component.setState({ loading: false });
  }
};

export const animatePlaceHolderText = (inputElement, textString, ms) => {
  let str = '';
  let n = 0;
  let interval = null;
  const intervalFunc = () => {
    n += 1;
    if (str !== textString) {
      str += textString[n - 1];
      inputElement.placeholder = str;
    } else {
      setTimeout(() => {
        inputElement.placeholder = '';
        n = 0;
        str = '';
        interval = setInterval(intervalFunc, ms);
      }, ms * 5);
      clearInterval(interval);
    }
  };
  interval = setInterval(intervalFunc, ms);
};
